<template>
    <v-container fluid pa-0 @click.stop="drawer = false">
        <v-navigation-drawer v-model="drawer" app disable-resize-watcher
                             class="app-navigation-drawer" overlay-opacity="0">
            <v-list v-for="menuItem in navigationContent" :key="menuItem.id">

                <v-list-item>
                    <v-list-item-action>
                        <v-icon class="white--text">{{menuItem.icon}}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title class="white--text"><a :href="menuItem.url" target="_blank"
                                                                  class="app-nav-drawer-item">{{ $t(menuItem.text)
                            }} </a>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

            </v-list>
        </v-navigation-drawer>

        <v-app-bar class="app-navigation-drawer" height="40px">
            <v-app-bar-nav-icon @click.stop="drawer = !drawer" id="app-menu-icon"></v-app-bar-nav-icon>
            <v-spacer/>
            <v-toolbar-title v-if="isFungusApp">{{ $t('structure.appTitleFungi') }}</v-toolbar-title>
            <v-toolbar-title v-else-if="isLichenApp">{{ $t('structure.appTitleLichens') }}</v-toolbar-title>
            <v-spacer/>

            <div>

                <select v-model="selectedLang" id="app-locale-changer" :title="$t('title.language')">
                    <option v-for="lang in languages" :key="lang" :value="lang"
                            class="app-locale-changer-option">{{ lang }}
                    </option>
                </select>
            </div>
        </v-app-bar>
    </v-container>
</template>

<script>

    export default {
        name: 'ApplicationHeader',
        data() {
            return {
                languages: ['de', 'fr', 'it', 'en'],
                navigationContent: [
                    {id: 'EM', text: '', url: '', icon: ''}, // keep empty icon for vertical spacing

                ],
                drawer: false,
                clipped: false,
                selectedLang: this.$store.state.lang
            }
        },
        computed: {
            lang() {
                return this.selectedLang
            },
            isFungusApp() {
                return this.$store.getters.isFungusApp
            },
            isLichenApp() {
                return this.$store.getters.isLichenApp
            },

        },
        watch: {
            lang() {
                this.$store.commit('setLang', this.lang)
                let url = process.env.BASE_URL + 'search?taxon=' + this.$store.state.taxonId + '&start=' + this.$store.state.yearRange.min + '&end=' + this.$store.state.yearRange.max + '&lang=' + this.$store.state.lang
                this.$store.commit('setQueryURL', url)
            },
            isFungusApp(){
                this.loadMenu()
            },
            isLichenApp(){
                this.loadMenu()
            }
        },
        methods: {
          loadMenu() {
                if (this.isFungusApp) {
                    this.navigationContent.push(
                        {id: 'SF', text: 'SwissFungi', url: 'https://swissfungi.wsl.ch/en/index.html', icon: 'home'},
                        {
                            id: 'SU',
                            text: 'structure.substratelist',
                            url: 'https://swissfungi.wsl.ch/de/verbreitungsdaten/substratliste.html',
                            icon: 'mdi-leaf'
                        },
                        {id: 'CF', text: 'structure.contact', url: 'https://www.wsl.ch/de/mitarbeitende/gross.html', icon: 'mdi-email-outline'}

                    )
                } else {
                    this.navigationContent.push(
                        {id: 'SL', text: 'SwissLichens', url: 'https://swisslichens.wsl.ch/de/index.html', icon: 'home'},
                        {
                            id: 'SU',
                            text: 'structure.substratelist',
                            url: 'http://merkur.wsl.ch/didado/lichenweb2.substrat',
                            icon: 'mdi-leaf'
                        },
                        {id: 'CL', text: 'structure.contact', url: 'https://www.wsl.ch/de/mitarbeitende/stofer.html', icon: 'mdi-email-outline'}
                    )
                }
            }
        }
    }


</script>

<style scoped lang="scss">
    @import '../../../global';

    .app-nav-drawer-item {
        color: $app-light-antique
    }

    .app-navigation-drawer {
        background-color: $app-black !important;
        color: white !important;
    }

    #app-locale-changer {
        background-color: $app-light-yellow;
        padding: 3px;
        margin: 3px;
        border-radius: 5px;
        color: black;
        text-decoration: none;
        text-transform: uppercase;
        text-align: center;
        font-size: 15px;
        font-weight: 700;
        line-height: 24px;
        display: block;
    }


    .app-locale-changer-option {
        background-color: $app-light-yellow;
    }

    #app-menu-icon {
        color: $app-light-yellow;
    }

</style>
